// extracted by mini-css-extract-plugin
module.exports = {"timeContainer":"untilFixed_timeContainer__MiboC","icon":"untilFixed_icon__14enS","clock":"untilFixed_clock__toioD","utcText":"untilFixed_utcText__2e_D_"};